import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Done, Error } from "@material-ui/icons";

import { Toast } from "../Toast/Toast";
import { notificationActions } from "../../_redux/_actions";
import { useStyles } from "./Notifications.styles";

const Notifications = () => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const { notifications } = useSelector((state) => state.notificationReducer);

  return (
    <ul className={classes.notifications}>
      {notifications.map((notification) => {
        const { id, message, severity } = notification;
        return (
          <Toast
            open={true}
            key={id}
            message={message}
            severity={severity}
            handleClose={(event, reason) => {
              if (reason === "clickaway") {
                return;
              }
              dispatch(notificationActions.removeNotification(id));
            }}
            icon={severity === "error" ? <Error /> : <Done />}
            duration={2000}
          />
        );
      })}
    </ul>
  );
};

export { Notifications };
